<template>
  <b-container class="blog-post">
    <b-row>
      <b-col md="10" offset-md="1">
        <br>
        <p class="blog-date">08/15/18</p>
        <h1>GREAT ACTIVITIES AT PETTICOAT CREEK CONSERVATION AREA</h1>
        <div class="blog-content">
        <br>
        <b-img fluid src="/img/blogs/activities-01.jpg" alt="A person hiking in the woods" class="mb-15"/>
        <p>One place, unlimited possibilities! Petticoat Creek Conservation Area is filled
          with tons of incredible
          amenities and natural beauty. With winding trails, gorgeous waterfront scenery, and lots of
          family-friendly amenities, you’ll love having so many things to do in one great place!</p>

        <br><br>

        <b-img fluid src="/img/blogs/activities-02.jpg" alt="Person submerged in a Petticool pool" class="mb-15" />
        <p class="subtitle">Go for a Swim</p>
        <p>There’s no better way to beat the heat than at the incredible Petticoat pool!
          Featuring a fully accessible
          1,600-square-metre pool that can hold up to 800 people (wow!), the conservation area also has a large
          splash pad and water play area that is sure to keep kids entertained for hours.</p>

        <br><br>
        
        <b-img fluid src="/img/blogs/activities-03.jpg" alt="Person standing in a hike trail" class="mb-15" />
        <p class="subtitle">Enjoy A Hike</p>
        <p>Adventure is calling, will you answer? Petticoat Creek is full of winding
          trails just waiting to be explored,
          and offers both easy and difficult terrain for all kinds of skill and age levels. Feel free to bring
          along your
          favourite four-legged friends as well, since each family is allowed up to three on-leash animals to join
          in
          on the fun!</p>

        <br><br>

        <b-img fluid src="/img/blogs/activities-04.jpg" alt="A bridge in Waterfront Trail" class="mb-15" />
        <p class="subtitle">Walk Along the Waterfront Trail</p>
        <p>Boasting some of the most jaw-dropping views of Lake Ontario, visitors can
          enjoy a leisurely walk
          through the Waterfront Trail bridge that crosses across the creek. Snap some incredible pictures, or
          just enjoy a quiet moment with loved ones as you view the lake from the top of the bluffs. We promise
          it’ll be a moment you won’t forget!</p>

        <br><br>

        <b-img fluid src="/img/blogs/activities-05.jpg" alt="Bike leaning against a tree" class="mb-15" />
        <p class="subtitle">Go for a Bike Ride</p>
        <p>The Petticoat Creek Conservation Area is a cyclist’s paradise! Designed for
          riders of all ages and skill
          levels, enjoy rolling terrain and long downhills that will both excite and entice you. Enjoy a bike wash
          station, shower and washroom facilities, but full-service campground and parking with every visit.</p>

        <br><br>

        <b-img fluid src="/img/blogs/activities-06.jpg" alt="Close up shot of a fox" class="mb-15" />
        <p class="subtitle">Watch the Wildlife</p>
        <p>Home to an incredibly vast amount of wildlife, Petticoat Creek is the ultimate
          spot for photographers,
          bird-watchers, or all-around nature-lovers. Home to over 70 types of trees, the area also provides a
          natural habitat for many species of mammals, colonial waterbirds, waterfowl and shorebirds to live.</p>

        <br><br>

        <b-img fluid src="/img/blogs/activities-07.jpg" alt="Petticoat picnic site" class="mb-15" />
        <p class="subtitle">Set Up a Picnic</p>
        <p>Whether you’re looking for a spot to eat after a fun-filled day at the park, or
          looking for a beautiful space
          to host an event, Petticoat has 6 picnic sites that are able to accommodate any size party!</p>
        <br>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
  export default {
    transition: {
      mode: 'out-in',
      css: false,
      appear: true,

      enter(el, done) {
        this.$root.layout.methods.triggerBlogEnterAnimation(done)
      },
      leave(el, done) {
        this.$root.layout.methods.triggerBlogLeaveAnimation(done)
      },
    },
  }

</script>

<style scoped>

</style>